/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IServerParent } from '../../core/models/common/IServerParent';
import { Server } from '../../core/models/common/Server';
import { Oas30Server } from '../../openapi/v3/models/Oas30Server';

/**
 * A command used to delete all servers from a document.
 * 
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllServersCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _oldServers : Array<any>;

    public constructor(parent? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IServerParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IServerParent") >= 0)) || parent === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldServers===undefined) this._oldServers = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldServers===undefined) this._oldServers = null;
            (() => {
                this._parentPath = Library.createNodePath(<Node><any>parent);
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldServers===undefined) this._oldServers = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldServers===undefined) this._oldServers = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllServersCommand] Executing.");
        this._oldServers = <any>([]);
        let parent : IServerParent = <IServerParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let servers : Array<Server> = parent.getServers();
        if(!this.isNullOrUndefined(servers)) {
            servers.forEach((server) => {
                /* add */(this._oldServers.push(Library.writeNode(server))>0);
            });
        }
        NodeCompat.setProperty(parent, Constants.PROP_SERVERS, <any>([]));
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllServersCommand] Reverting.");
        if(/* size */(<number>this._oldServers.length) === 0) {
            return;
        }
        let parent : IServerParent = <IServerParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let servers : Array<Server> = parent.getServers();
        if(this.isNullOrUndefined(servers)) {
            servers = <any>([]);
            NodeCompat.setProperty(parent, Constants.PROP_SERVERS, servers);
        }
        for(let index202=0; index202 < this._oldServers.length; index202++) {
            let oldServer = this._oldServers[index202];
            {
                let server : Oas30Server = <Oas30Server>parent.createServer();
                Library.readNode(oldServer, server);
                /* add */(servers.push(server)>0);
            }
        }
    }
}
DeleteAllServersCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllServersCommand";
DeleteAllServersCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

